import { getQuery, getDynamicQuery } from './query';
import getMutation, { getDynamicMutation } from './mutation';

export { getQuery, getDynamicQuery, getMutation, getDynamicMutation };
